var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuizIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "quiz 1",
    clipPath: "url(#clip0_607_1993)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M104 95.5447C104 100.159 100.303 103.911 95.7096 103.998C90.9695 104.089 87.0894 100.119 87.0894 95.3778V32.1301H99.7723C102.107 32.1301 104 34.0228 104 36.3578V95.5447Z",
    fill: "#B3E59F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M95.5447 104H8.45528C3.78564 104 0 100.214 0 95.5447V4.22764C0 1.89272 1.89272 0 4.22764 0H82.8618C85.1967 0 87.0894 1.89272 87.0894 4.22764V95.5447C87.0894 100.214 90.8751 104 95.5447 104Z",
    fill: "#ECF4FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M80.3253 4.22764V97.2357C80.3253 100.002 81.6537 102.457 83.7073 104H95.5448C90.8752 104 87.0896 100.214 87.0896 95.5447V4.22764C87.0896 1.89272 85.1968 0 82.8619 0H76.0977C78.4326 0 80.3253 1.89272 80.3253 4.22764Z",
    fill: "#DDEAFB"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M76.0974 9.08948H10.9918C8.65688 9.08948 6.76416 10.9822 6.76416 13.3171V35.3009C6.76416 37.6359 8.65688 39.5286 10.9918 39.5286H76.0974C78.4323 39.5286 80.3251 37.6359 80.3251 35.3009V13.3171C80.3251 10.9822 78.4323 9.08948 76.0974 9.08948Z",
    fill: "#FFE07D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M76.0976 9.08948H71.2358C73.5708 9.08948 75.4635 10.9822 75.4635 13.3171V35.3009C75.4635 37.6359 73.5708 39.5286 71.2358 39.5286H76.0976C78.4326 39.5286 80.3253 37.6359 80.3253 35.3009V13.3171C80.3253 10.9822 78.4326 9.08948 76.0976 9.08948Z",
    fill: "#FFD064"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M29.9788 30.1182C31.1496 28.4779 31.8414 26.4733 31.8414 24.309C31.8414 18.7814 27.3445 14.2842 21.8166 14.2842C16.289 14.2842 11.792 18.7814 11.792 24.309C11.792 29.8366 16.289 34.3336 21.8166 34.3336C24.0496 34.3336 26.1139 33.5991 27.782 32.3601L29.2274 33.8055C29.5339 34.112 29.9355 34.2654 30.3371 34.2654C30.7387 34.2654 31.1405 34.112 31.4468 33.8057C32.0598 33.1929 32.0598 32.1992 31.4468 31.5862L29.9788 30.1182ZM21.8166 31.1947C18.0198 31.1947 14.9309 28.1058 14.9309 24.309C14.9309 20.512 18.0198 17.4231 21.8166 17.4231C25.6136 17.4231 28.7026 20.512 28.7026 24.309C28.7026 25.6056 28.342 26.8192 27.7164 27.8558L26.0371 26.1763C25.4243 25.5635 24.4306 25.5633 23.8176 26.1761C23.2046 26.789 23.2046 27.7826 23.8176 28.3957L25.5271 30.1052C24.4552 30.7936 23.1822 31.1947 21.8166 31.1947Z",
    fill: "#DF75A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M56.1836 14.2842C55.3167 14.2842 54.6143 14.9868 54.6143 15.8535V32.7643C54.6143 33.6312 55.3169 34.3336 56.1836 34.3336C57.0503 34.3336 57.7529 33.631 57.7529 32.7643V15.8535C57.7529 14.9868 57.0503 14.2842 56.1836 14.2842Z",
    fill: "#DF75A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M73.7285 31.1947H65.3431L74.7809 16.7103C75.0952 16.2279 75.1202 15.612 74.8457 15.1058C74.5713 14.5994 74.0418 14.2842 73.4659 14.2842H62.7941C61.9272 14.2842 61.2248 14.9868 61.2248 15.8535C61.2248 16.7205 61.9274 17.4229 62.7941 17.4229H70.5702L61.1324 31.9073C60.8181 32.3897 60.7931 33.0056 61.0676 33.5118C61.342 34.0182 61.8715 34.3334 62.4474 34.3334H73.7285C74.5955 34.3334 75.2979 33.6308 75.2979 32.7641C75.2979 31.8974 74.5953 31.1947 73.7285 31.1947Z",
    fill: "#DF75A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M49.3326 14.2844C48.4659 14.2844 47.7633 14.987 47.7633 15.8538V27.4776C47.7633 28.3685 47.5224 29.6744 45.4395 30.7233C44.8165 31.0372 44.1103 31.1917 43.3542 31.1948C42.5009 31.1936 41.7571 30.9827 41.0799 30.5501C39.7102 29.675 39.1514 28.7886 39.1514 27.49V15.8538C39.1514 14.9868 38.4488 14.2844 37.582 14.2844C36.7153 14.2844 36.0127 14.987 36.0127 15.8538V27.49C36.0127 29.8775 37.1175 31.7436 39.3901 33.1954C40.569 33.9485 41.9013 34.3318 43.35 34.3339H43.3611C44.614 34.3339 45.7883 34.0623 46.8514 33.5269C50.1991 31.8409 50.902 29.3067 50.902 27.4778V15.8538C50.9022 14.987 50.1994 14.2844 49.3326 14.2844Z",
    fill: "#DF75A5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M61.7234 59.6995H27.0566C26.1899 59.6995 25.4873 58.9969 25.4873 58.1301C25.4873 57.2634 26.1899 56.5608 27.0566 56.5608H61.7234C62.5903 56.5608 63.2927 57.2634 63.2927 58.1301C63.2927 58.9969 62.5903 59.6995 61.7234 59.6995Z",
    fill: "#4A80AA"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M69.3331 51.2444H39.3169C38.4502 51.2444 37.7476 50.5418 37.7476 49.6751C37.7476 48.8081 38.4502 48.1057 39.3169 48.1057H69.3331C70.2 48.1057 70.9024 48.8083 70.9024 49.6751C70.9024 50.5418 70.2 51.2444 69.3331 51.2444Z",
    fill: "#4A80AA"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M31.9184 51.2444H27.0566C26.1899 51.2444 25.4873 50.5418 25.4873 49.6751C25.4873 48.8081 26.1899 48.1057 27.0566 48.1057H31.9184C32.7852 48.1057 33.4878 48.8083 33.4878 49.6751C33.488 50.5418 32.7852 51.2444 31.9184 51.2444Z",
    fill: "#4A80AA"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M61.7234 74.919H27.0566C26.1899 74.919 25.4873 74.2163 25.4873 73.3496C25.4873 72.4827 26.1899 71.7803 27.0566 71.7803H61.7234C62.5903 71.7803 63.2927 72.4829 63.2927 73.3496C63.2929 74.2163 62.5903 74.919 61.7234 74.919Z",
    fill: "#4A80AA"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M69.3331 66.4636H39.3169C38.4502 66.4636 37.7476 65.761 37.7476 64.8943C37.7476 64.0276 38.4502 63.325 39.3169 63.325H69.3331C70.2 63.325 70.9024 64.0276 70.9024 64.8943C70.9024 65.761 70.2 66.4636 69.3331 66.4636Z",
    fill: "#4A80AA"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M31.9184 66.4636H27.0566C26.1899 66.4636 25.4873 65.761 25.4873 64.8943C25.4873 64.0276 26.1899 63.325 27.0566 63.325H31.9184C32.7852 63.325 33.4878 64.0276 33.4878 64.8943C33.4878 65.761 32.7852 66.4636 31.9184 66.4636Z",
    fill: "#4A80AA"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M18.6015 48.1055H6.76417C5.89743 48.1055 5.19482 48.8081 5.19482 49.6748V58.1301C5.19482 58.997 5.89743 59.6994 6.76417 59.6994H18.6017C19.4684 59.6994 20.171 58.9968 20.171 58.1301V49.6748C20.171 48.8081 19.4684 48.1055 18.6015 48.1055Z",
    fill: "#DF75A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M18.6015 63.325H6.76417C5.89743 63.325 5.19482 64.0276 5.19482 64.8943V73.3496C5.19482 74.2165 5.89743 74.9189 6.76417 74.9189H18.6017C19.4684 74.9189 20.171 74.2163 20.171 73.3496V64.8943C20.171 64.0274 19.4684 63.325 18.6015 63.325Z",
    fill: "#DF75A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M18.6015 78.5444H6.76417C5.89743 78.5444 5.19482 79.247 5.19482 80.1138V88.5691C5.19482 89.436 5.89743 90.1384 6.76417 90.1384H18.6017C19.4684 90.1384 20.171 89.4358 20.171 88.5691V80.1138C20.171 79.247 19.4684 78.5444 18.6015 78.5444Z",
    fill: "#DF75A5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M61.7234 90.1384H27.0566C26.1899 90.1384 25.4873 89.4358 25.4873 88.5691C25.4873 87.7024 26.1899 86.9998 27.0566 86.9998H61.7234C62.5903 86.9998 63.2927 87.7024 63.2927 88.5691C63.2927 89.4358 62.5903 90.1384 61.7234 90.1384Z",
    fill: "#4A80AA"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M69.3331 81.6834H39.3169C38.4502 81.6834 37.7476 80.9808 37.7476 80.114C37.7476 79.2473 38.4502 78.5447 39.3169 78.5447H69.3331C70.2 78.5447 70.9024 79.2473 70.9024 80.114C70.9024 80.9808 70.2 81.6834 69.3331 81.6834Z",
    fill: "#4A80AA"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M31.9184 81.6834H27.0566C26.1899 81.6834 25.4873 80.9808 25.4873 80.114C25.4873 79.2473 26.1899 78.5447 27.0566 78.5447H31.9184C32.7852 78.5447 33.4878 79.2473 33.4878 80.114C33.4878 80.9808 32.7852 81.6834 31.9184 81.6834Z",
    fill: "#4A80AA"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_607_1993"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 104,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuizIcon);
export default __webpack_public_path__ + "static/media/QuizIcon.e52334368539f0d3e05324c46ce95bbc.svg";
export { ForwardRef as ReactComponent };